import type { SelectorObject } from '../types';

export const addItemButtonSelectors = {
  button: 'add-item-button-button',
  menuItems: {
    fixedFeeItem: 'add-item-button-menu-item-fixed-fee',
    subscriptionFeeItem: 'add-item-button-menu-item-subscription-fee',
    tieredPricingItem: 'add-item-button-menu-item-tiered-pricing',
    perUnitPricingItem: 'add-item-button-menu-item-per-unit-pricing',
    volumeBasedTiersItem: 'add-item-button-menu-item-volume-based-tiers',
    promotionsItem: 'add-item-button-menu-item-promotions',
    commissionItem: 'add-item-button-menu-item-commission',
    fixedPerUnitItem: 'add-item-button-menu-item-fixed-per-unit',
    installmentsItem: 'add-item-button-menu-item-installments',
    commercialTermsItem: 'add-item-button-menu-item-commercial-terms',
  },
} satisfies SelectorObject<'add-item-button-'>;